import { render } from "./listContent.vue?vue&type=template&id=b89db00e"
import script from "./listContent.vue?vue&type=script&lang=js"
export * from "./listContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__